// Auto-generated from proto definitions. DO NOT EDIT.

export type SignatureLegalTier = 'SIGNATURE_LEGAL_TIER_UNSPECIFIED' | 'SIGNATURE_LEGAL_TIER_QUALIFIED' | 'SIGNATURE_LEGAL_TIER_ADVANCED' | 'SIGNATURE_LEGAL_TIER_SIMPLE';

export const SignatureLegalTierValues = ['SIGNATURE_LEGAL_TIER_UNSPECIFIED', 'SIGNATURE_LEGAL_TIER_QUALIFIED', 'SIGNATURE_LEGAL_TIER_ADVANCED', 'SIGNATURE_LEGAL_TIER_SIMPLE'] as const;
